import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Dashboard",
		meta: { title: "Dashboard" },
		component: () => import("./views/Dashboard.vue")
	},
	{
		path: "/infraestrutura-ucg",
		name: "Localizacao",
		meta: { title: "Infraestrutura UCG" },
		component: () => import("./views/Location.vue")
	},
	{
		path: "/modulos",
		name: "Modulos",
		meta: { title: "Módulos MMI" },
		component: () => import("./views/Modules.vue")
	},
	{
		path: "/infraestrutura-mmi",
		name: "Sistema",
		meta: { title: "Infraestrutura MMI" },
		component: () => import("./views/System.vue")
	},
	{
		path: "/machines",
		name: "Prensas",
		meta: { title: "Máquinas" },
		component: () => import("./views/Machines.vue")
	},
	{
		name: "404",
		path: "*",
		meta: { title: "404 - Página não encontrada" },
		component: () => import("./views/NotFound.vue")
	}
];

const router = new VueRouter({
	mode: "history",
	routes
});

router.beforeEach((to, from, next) => {
	document.title = to.meta.title ? `${to.meta.title} | MMI Monitor` : "MMI Monitor";
	next();
});

export default router;